<template>
    <div class="card h-100">
        <div class="card-header">
            <i class="fa-solid fa-file-invoice-dollar"></i> Cartera
        </div>
        <div class="card-body">
            <form>
                <div class="form-group row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <base-select-forms v-model="formData.codAlmacen" title="Almacenes" idSelect="codAlmacen"
                            :options="shopAuthorizedLists" optionName="nombreAlmacen" optionId="codAlmacen"
                            :errors="alert.errorsFields" :onChange="loadGraphics"></base-select-forms>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <base-select-forms v-model="formData.tipoRangoFecha" title="Fecha"
                            idSelect="tipoRangoFechaSolicitud" :options="reportsParameters.rangoFechaFiltro"
                            optionName="1" optionId="0" :errors="alert.errorsFields"
                            :onChange="loadGraphics"></base-select-forms>
                    </div>
                </div>
            </form>
            <widget-loading v-if="isLoading.creditGraphics" />
            <canvas v-show="!isLoading.creditGraphics" id="graphicsCredit"></canvas>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-end">
                <base-button-forms classButton="btn-primary" icon="fa-solid fa-file-export" :permissionId="70"
                    :onClick="onExportToExcel" :isLoading="isLoading['creditGraphicsExport']"
                    :disabled="isLoading['creditGraphicsExport']"></base-button-forms>
            </div>
        </div>
    </div>
</template>

<script>

import { ref, computed, onMounted } from 'vue'
import Chart from 'chart.js/auto';


import useReports from '@/modules/reports/composables/useReports'
import graphics from '@/helpers/graphics'
import WidgetLoading from '@/common/widgets/WidgetLoading.vue';
import BaseSelectForms from '@/common/forms/BaseSelectForms.vue';
import useShop from '@/modules/shop/composables/useShop'
import BaseButtonForms from '@/common/forms/BaseButtonForms.vue';





export default {
    components: {
        WidgetLoading,
        BaseSelectForms,
        BaseButtonForms
    },

    setup() {
        const {
            getDataReports,
            creditGraphics,
            isLoading,
            alert,
            reportsParameters,
            exportToExcel
        } = useReports()

        const { barGraphicsOptions } = graphics()

        const { shopAuthorizedLists } = useShop()

        const formData = ref({
            codAlmacen: '',
            tipoRangoFecha: '0',
            tipoReporte:'GC'
        })

        let myChart
        const loadGraphics = async () => {
            try {
                if (myChart) {
                    myChart.clear();
                    myChart.destroy();
                }
                const { response } = await getDataReports(formData.value, 'creditGraphics')
                if (response) {
                    const ctx = document.getElementById('graphicsCredit')
                    const opcionesGrafico = barGraphicsOptions({
                        tipoInforme: 'Cartera',
                        labels: creditGraphics.value.labels,
                        datasets: creditGraphics.value.datasets,
                        titulo: 'Cartera',
                        subtitulo: 'Estado actual de la cartera',
                        textoEjeX: 'Días',
                        textoEjeY: 'Monto adeudado',
                        tipoDato: 'monto'

                    })
                    myChart = new Chart(ctx, opcionesGrafico, 'monto');
                    myChart
                }
            } catch (error) {
                console.log(error)
            }
        }

        onMounted(async () => {
            loadGraphics()
        })
        return {
            creditGraphics,
            isLoading,
            alert,
            formData,
            reportsParameters,
            shopAuthorizedLists,

            loadGraphics,
            onExportToExcel: async () => {
                await exportToExcel(formData.value, 'creditGraphics')
            }

        }
    },


}
</script>